// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import Select2, { DataSelect2 } from 'wdna-select2';
import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

import { LovDO } from '../../../configuration/requests';
import { CompanyDO } from '../../requests';

interface Props {
  formValues: {
    id?: number;
    data: Partial<CompanyDO>;
    isFile: boolean;
    modalShow: boolean;
    typeCompanyArray: LovDO[];
  };
  fileId: string;
  fileName: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onChangeFile: (e: React.ChangeEvent<HTMLInputElement>) => void;
  download: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCloseModal: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleUploadFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleDeletedFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showFreeboard: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function Form(props: Props): JSX.Element {
  const { formValues, fileName, fileId } = props;
  const { id, data, modalShow, isFile } = formValues;
  const { typeCompanyArray } = formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.name"
            name="data.name"
            value={_.defaultTo(data.name, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Name"
            required
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Code</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.code"
            name="data.code"
            value={_.defaultTo(data.code, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Code"
            required
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Type</b> &nbsp;
          </label>
          <span className="mandatory">
            <Select2
              id="data.type"
              name="data.type"
              value={_.defaultTo(data.type, '')}
              onChange={props.onChange}
              data={typeCompanyArray.map((item: LovDO): DataSelect2 => {
                return { id: item.id, text: item.name };
              })}
              options={{ placeholder: 'Select option' }}
              style={{ width: '80%' }}
              required
            />
          </span>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Contact</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.contact"
            name="data.contact"
            value={_.defaultTo(data.contact, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Contact"
            required
          />
        </div>
        <div className="col-3">
          <label className="label">
            <b>Phone</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.phone"
            name="data.phone"
            value={_.defaultTo(data.phone, '')}
            onChange={props.onChange}
            className="input-new"
            style={{ width: '80%' }}
            placeholder="Phone"
          />
        </div>
        <div className="col-3">
          <label className="label">
            <b>E-mail</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.email"
            name="data.email"
            value={_.defaultTo(data.email, '')}
            onChange={props.onChange}
            className="input-new"
            style={{ width: '80%' }}
            placeholder="E-mail"
          />
        </div>
      </div>
      <ContainerModal
        fullScreenButton={false}
        show={modalShow}
        title="SELECT DASHBOARD"
        modalClass="selector-modal"
        onClose={props.onCloseModal}
        footerButtons={[
          {
            text: 'OK',
            className: 'btn btn-primary',
            onClick: props.onCloseModal,
          },
        ]}
      >
        <div>
          <label className="label">
            <b>Selected File</b>
          </label>
          <div className="input input-file">
            <span className="button">
              <input
                type="file"
                id={fileId}
                name="file"
                onChange={props.onChangeFile}
                style={{ width: '75%' }}
                accept=".json"
                required={!id}
              />
              <br />
              <label className="label">
                <b>Browse</b>
              </label>
              <br />
            </span>
            <div className="cl-element btn-select2-addon">
              <input type="text" id={fileName} placeholder="Include some files" readOnly style={{ width: '55%' }} />
              &nbsp;&nbsp;
              <button
                type="button"
                onClick={props.onHandleUploadFile}
                className="btn btn-default"
                style={{ right: 'unset' }}
              >
                Save
              </button>
              <div hidden={!isFile}>
                <button
                  type="button"
                  onClick={props.onHandleDeletedFile}
                  className="btn btn-default"
                  style={{ right: '40px', top: '0px' }}
                >
                  Delete
                </button>
              </div>
            </div>
            <br />
            <label className="label">
              <b>Old File</b>
            </label>
            <div hidden={isFile}>
              <input
                type="text"
                value="No files in server"
                className="input-new"
                style={{ width: '55%' }}
                readOnly
                size={50}
              />
            </div>
            <div hidden={!isFile} className="cl-element btn-select2-addon">
              <input
                type="text"
                value={`company_${data.id}.json`}
                className="input-new"
                style={{ width: '55%' }}
                readOnly
                size={50}
              />
              &nbsp;&nbsp;
              <button
                type="button"
                onClick={props.download}
                className="btn btn-default"
                style={{ right: 'unset' }}
              >
                Download
              </button>
              <button
                type="button"
                onClick={props.showFreeboard}
                className="btn btn-default"
                style={{ right: '40px' }}
              >
                Show
              </button>
            </div>
          </div>
        </div>
      </ContainerModal>
    </fieldset>
  );
}

export default Form;
